import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import { Moon, Sun, Monitor } from 'lucide-react';

const ICONS = { dark: Moon, light: Sun, system: Monitor } as const;
const LABELS = { dark: 'Dark mode', light: 'Light mode', system: 'System preference' } as const;
const NEXT_LABEL = { dark: 'Switch to light', light: 'Switch to system', system: 'Switch to dark' } as const;

export function ThemeToggle() {
  const { mode, cycle } = useTheme();
  const Icon = ICONS[mode];

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      className="h-8 w-8 text-wt-text-muted hover:text-wt-text-primary"
      title={`${LABELS[mode]} - ${NEXT_LABEL[mode]}`}
    >
      <Icon className="h-4 w-4" />
      <span className="sr-only">{LABELS[mode]}</span>
    </Button>
  );
}
